const seeds = [
  "Small steps still count.",
  "You are not behind. You are growing.",
  "Plant the seed. Keep going.",
  "Progress often hides before it reveals itself.",
  "You do not need everything figured out to take the next step.",
  "Roots grow before fruit appears.",
  "Rest is not quitting.",
  "Every setback can still teach you something.",
  "Your story has value.",
  "Keep showing up, even when it feels slow.",
  "Growth does not need to be loud to be real.",
  "One honest step is still progress.",
  "The slow valley is where roots grow.",
  "You are allowed to start again.",
  "Failure is part of growth.",
  "You do not have to be perfect to be useful.",
  "Someone needs the lesson you are learning right now.",
  "Stay patient with your process.",
  "Every expert was once confused.",
  "Your small win still matters.",
  "Do not measure your growth by someone else's timeline.",
  "Keep watering what you planted.",
  "The seed is still alive underground.",
  "You are building something real.",
  "Faithful steps become a path.",
  "You can be tired and still be growing.",
  "Start where you are.",
  "Learn one thing today.",
  "Keep your heart right and your steps honest.",
  "Plant the seed. Trust the process. Keep going."
];

export default seeds;